export default "__VITE_ASSET__CVbxr_5___"